import { suggest_Close_str, direction_Shrink_str, direction_Swell_str } from '@zenlayer/zen-design-icons';
import Button from '../../button';
import SvgIcon from '../../svg-icon';
import { Drawer, Tabs } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { getActiveId, removeTab, removeTabs, setActive, useAddTabsEventListener } from './event';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  TabPane
} = Tabs;
const RenderComponent = _ref => {
  let {
    tab
  } = _ref;
  useEffect(() => {
    var _tab$render;
    const container = document.getElementById(tab.id);
    const unmount = tab === null || tab === void 0 || (_tab$render = tab.render) === null || _tab$render === void 0 ? void 0 : _tab$render.call(tab, tab.component, container);
    //  if (ReactDOM.createRoot) {
    //    // React 18 or higher
    //    ReactDOM.createRoot(container).render(element);
    //  } else {
    //    // React 16 or lower
    //    ReactDOM.render(element, container);
    //  }
    return () => {
      var _tab$render2;
      unmount ? unmount() : (_tab$render2 = tab.render) === null || _tab$render2 === void 0 ? void 0 : _tab$render2.call(tab, /*#__PURE__*/React.createElement('div'), container);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    id: tab.id
  });
};
const defaultDrawerWidth = '80%';
const GlobalDrawer = props => {
  const {
    className
  } = props;
  const tabs = useAddTabsEventListener();
  const [drawerWidth, setDrawerWidth] = useState(defaultDrawerWidth);
  const [afterVisible, afterOpenChange] = useState(false);

  // useEffect(() => {
  //   if (tabs.length === 0) {
  //     if (getTabInfoOfUrl()?.showDetail) {
  //       history.replace({
  //         hash: '',
  //       });
  //     }

  //     setDrawerWidth(defaultDrawerWidth);
  //   } else {
  //     if (!getTabInfoOfUrl()?.showDetail) {
  //       history.replace({
  //         hash: stringify({
  //           showDetail: true,
  //           name: tabs[0].name,
  //           type: tabs[0].type,
  //           id: tabs[0].id,
  //         }),
  //       });
  //     }
  //   }
  // }, [tabs]);

  const extraLeftDom = useMemo(() => {
    return /*#__PURE__*/_jsxs("div", {
      className: "extra-left",
      children: [/*#__PURE__*/_jsx(Button, {
        type: "text",
        textBaseColor: true,
        size: "s",
        icon: /*#__PURE__*/_jsx(SvgIcon, {
          svgStr: suggest_Close_str
        }),
        onClick: () => {
          removeTabs();
        }
      }), drawerWidth === '100%' ? /*#__PURE__*/_jsx(Button, {
        type: "text",
        textBaseColor: true,
        size: "s",
        icon: /*#__PURE__*/_jsx(SvgIcon, {
          svgStr: direction_Shrink_str
        }),
        onClick: () => {
          setDrawerWidth(defaultDrawerWidth);
        }
      }) : /*#__PURE__*/_jsx(Button, {
        type: "text",
        textBaseColor: true,
        size: "s",
        icon: /*#__PURE__*/_jsx(SvgIcon, {
          svgStr: direction_Swell_str
        }),
        onClick: () => {
          setDrawerWidth('100%');
        }
      })]
    });
  }, [drawerWidth]);
  const tabTtems = useMemo(() => {
    return tabs.map(tab => ({
      label: /*#__PURE__*/_jsxs("span", {
        className: "tabName",
        children: [tab.icon && /*#__PURE__*/React.cloneElement(tab.icon, {
          className: 'icon'
        }), tab.name, /*#__PURE__*/_jsx(SvgIcon, {
          svgStr: suggest_Close_str,
          className: "closeIcon",
          onClick: () => {
            tab.id && removeTab(tab.id);
          }
        })]
      }),
      key: tab.id,
      children: tab.render ? /*#__PURE__*/_jsx(RenderComponent, {
        tab: tab
      }) : tab.component
    }));
  }, [tabs]);
  return /*#__PURE__*/_jsx(Drawer, {
    placement: "right",
    closable: false,
    open: !!(tabs !== null && tabs !== void 0 && tabs.length),
    getContainer: false,
    rootClassName: classNames(className, "globalDrawer"),
    mask: false,
    width: drawerWidth,
    afterOpenChange: open => {
      if (!open) {
        setDrawerWidth(defaultDrawerWidth);
      }
      afterOpenChange(open);
    },
    children: afterVisible && /*#__PURE__*/_jsx("div", {
      className: "globalDrawer-content-wrap",
      children: /*#__PURE__*/_jsx(Tabs, {
        destroyInactiveTabPane: true,
        type: "card",
        activeKey: getActiveId(),
        onTabClick: key => {
          setActive(key);
        },
        tabBarExtraContent: {
          left: extraLeftDom
        },
        items: tabTtems
      })
    })
  });
};
export default GlobalDrawer;